export default __webpack_public_path__ + "static/media/3.dc07d274.jpg";